import Dinero from 'dinero.js';
import { IntlShape } from 'react-intl';

export {
  Dinero
};

const DEFAULT_DINEROJS_PRECISION = 2;

/**
 * Format an amount expressed in minor currency units into a string taking into account the currency and the locale.
 *
 * NOTE: This library is currently working with a default precission of 2, this means that for those
 * currencies which the precission is different to 2, we should pass it as parameter.
 * Table of currency codes and their precision:
 * @see https://en.wikipedia.org/wiki/ISO_4217#Treatment_of_minor_currency_units_(the_%22exponent%22)
 *
 * The v2 of the library will accept just the currency and will automatically determine the precission to
 * format the amount properly relying on the currency.
 * @see https://github.com/dinerojs/rfcs/pull/1
 *
 * @param {number} amount - expressed in minor currency units.
 * @param {string} currency - ISO 4217 currency code.
 * @param {IntlShape} intl - Intl object to determine the current locale.
 * @param {number} [precision=DEFAULT_DINEROJS_PRECISION] - Represent the number of decimal places in the amount
 * @returns {string} Formatted amount.
 */
export const formatMinorUnitsAmount = (
  amount: number,
  currency: string,
  intl: IntlShape,
  precision: number = DEFAULT_DINEROJS_PRECISION
): string => Dinero({ amount, currency, precision })
  .setLocale(intl.locale || intl.defaultLocale)
  .toFormat();
